// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "3b78de7acd6c06fe6ffdec1c96c4482c" + ".js";
};